<template>
  <div class="relative-match" :class="{'show-border': showBorderBottom}">
    <div class="player" v-if="relativeMatch.forPlayer && relativeMatch.player.stats.bat">
      <div  v-if="relativeMatch.didPlayerBat && (forMetric === null || forMetric === 'bat')">
        <div class="highlight main">
          {{relativeMatch.player.stats.bat.runs}}({{relativeMatch.player.stats.bat.balls}})<span v-if="relativeMatch.player.stats.bat.not_out">*</span>
        </div>
        <div class="silent">
          SR:{{relativeMatch.player.stats.bat.strike_rate}},
          {{relativeMatch.player.stats.bat['4s']}}x4s
          {{relativeMatch.player.stats.bat['6s']}}x6s
        </div>
      </div>

      <div  v-if="relativeMatch.didPlayerBowl && (forMetric === null || forMetric === 'bowl')">
        <div class="highlight main">
          {{relativeMatch.player.stats.bowl.wickets}}/{{relativeMatch.player.stats.bowl.balls | ballsAsOvers}}
        </div>
        <div class="silent">
          Econ: {{relativeMatch.player.stats.bowl.economy}},
          Runs: {{relativeMatch.player.stats.bowl.runs}}
        </div>
      </div>

      <div v-if="!relativeMatch.didPlayerBatOrBowl">
        <div class="highlight main">NP</div>
      </div>

      <div  v-if="forMetric === null"  class="silent">
        <div v-if="relativeMatch.player.stats.field.caught">
          Catches: {{relativeMatch.player.stats.field.caught}}
        </div>
        <div v-if="relativeMatch.player.stats.field.run_out">
          Run Outs: {{relativeMatch.player.stats.field.run_out}}
        </div>
        <div v-if="relativeMatch.player.stats.field.stumped">
          Stumped: {{relativeMatch.player.stats.field.stumped}}
        </div>
      </div>
    </div>
    <div class="match">
      <div class="head">
        <router-link class="clean" :to="{name:'cricketMatch', params: {key: relativeMatch.match.key}}">
            <span class="team">
            vs
            {{relativeMatch.match.teams[relativeMatch.vsTeamIndex].key | capitaliseUpper}}
            </span>
            -
            <span v-if="relativeMatch.match.result_by">
              <span v-if="!relativeMatch.match.result_by.kind">
                {{relativeMatch.match.result | capitalise}}
                *err
              </span>
              <span v-else>
                <span class="won" v-if="relativeMatch.match.result === 'win'">Won</span>
                <span class="lost" v-if="relativeMatch.match.result === 'lost'">Lost</span>
                by {{relativeMatch.match.result_by.difference}} {{relativeMatch.match.result_by.kind | capitalise}}s
              </span>
            </span>
            <span v-else-if="relativeMatch.match.result">
              {{relativeMatch.match.result | capitalise}}
            </span>
            <span v-else-if="relativeMatch.match.status_overview">
              {{relativeMatch.match.status_overview | capitalise}}
            </span>
            <span v-else>*err</span>
        </router-link>
        - {{relativeMatch.match.startAt | simpleDate}}
      </div>
      <div class="second-head">
        <span v-if="relativeMatch.match.related_name">{{relativeMatch.match.related_name}}, </span>
        <router-link class="clean" :to="{name:'cricketSeason', params: {key: relativeMatch.season.key}}">
          {{relativeMatch.season.name}}
        </router-link>
      </div>
      <div class="score" v-if="relativeMatch.match.played_innings && relativeMatch.match.played_innings.length > 0">
        <table>
          <tbody>
            <tr v-for="ti in ['a', 'b']" :key="ti">
              <td>
                <router-link class="clean" :to="{name:'cricketTeam', params: {key: relativeMatch.match.teams[ti].key}}">
                  {{relativeMatch.match.teams[ti].name}}
                </router-link>
                <span v-if="relativeMatch.match.winnerTeam == ti">&starf;</span>
              </td>
              <td v-for="inn in ['1', '2', '9', 'superover']" :key="inn">
                <div v-if="relativeMatch.match.innings[ti + '_' + inn]">
                  <span class="inn-score">{{relativeMatch.match.innings[ti + '_' + inn].runs}}/{{relativeMatch.match.innings[ti + '_' + inn].wickets}}</span> 
                  (SR: {{relativeMatch.match.innings[ti + '_' + inn].run_rate}})
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    forMetric: {
      type: String,
      default: null
    },
    showBorderBottom: {
      type: Boolean,
      default: true
    },
    relativeMatch: Object
  }
}
</script>
